export default "__VITE_ASSET__f77f140c__$_?nuxt_component=async__"